import { preloadSyncedBlocksData } from './preloadSyncedBlocksData.ts';
import type { JSONDocNode } from '@atlaskit/editor-json-transformer';

const MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/syncedBlocksData';

/**
 * Preloads synced blocks data for the editor and stores it in the window object for hydration.
 *
 * This is a convenience wrapper around the preloadSyncedBlocksData function,
 * providing editor-specific defaults.
 *
 * @param contentId - The ID of the content to preload synced blocks for
 * @param cloudId - The cloud ID associated with the content
 * @param isBlog - Whether the content is a blog post
 * @param doc - The ADF document (optional, if provided uses bulk load)
 * @returns Promise that resolves when synced blocks data is preloaded
 */
export async function preloadEditorSyncedBlocksData(
	contentId: string | null,
	cloudId?: string,
	isBlog?: boolean,
	doc?: JSONDocNode,
): Promise<void> {
	if (!contentId || !cloudId || typeof isBlog === 'undefined') {
		return;
	}

	return preloadSyncedBlocksData({
		contentId,
		cloudId,
		isBlog,
		doc,
		measureSegment: MEASURE_SEGMENT,
	});
}
